<div class='img-part'>
    <div class='img-box'>
        <!-- <i class="iconfont icon-baobao1"></i> -->
        <img [class]="nothingImageClass" [src]="nothingImage || '../../../../assets/icon/nothing/nothing-buy.png'"
            style="width: 15rem;" alt="">
        <p class="nothin-text text-muted">{{nothingText || ('SHARED.THERE_IS_NO_INFORMATION' | translate)}}</p>
    </div>
</div>